export const GET_BOOKED_ORDERS = "get_booked_orders";
export const UPDATE_ORDER = "update_order";
export const UPDATE_ORDERS = "update_orders";
export const FORCE_UPDATE_ORDER = "force_update_order";
